var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"oee-graph-container",attrs:{"wxid":_vm.$options.name}},[_c('figure',[_c('wx-chart-line-graph',{attrs:{"css-classes":"canvas-container","styles":{
        left: _vm.oeeGraphOffset,
        width: _vm.oeeGraphWidth,
      },"chart-data":_vm.oeeChartData,"chart-options":_vm.oeeChartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }